export default __webpack_public_path__ + "static/media/next_gen.68dc0d18.svg";